import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actionCreators from '../actions';

class ListItem extends Component {

   constructor(props) {
      super(props);

      this.handleLinkClick = this.handleLinkClick.bind(this);
   }

   handleLinkClick(path, e) {
      e.preventDefault();
      const {dispatch} = this.props;
      dispatch(push(path));
   }

   render() {
      const {primaryText, style, bookKey, articleKey, isItemLeaf, isActive} = this.props;
      const {onTouchTap, leftIcon} = this.props;
      const styles = {
         root: {
            cursor: 'pointer',
            transition: 'all 0.25s ease-in-out'
         },
         primaryText: {
            lineHeight: '32px'
         }
      };

      return (
         <div className={isActive ? "ActiveItem" : ""}
            style={Object.assign({}, styles.root, style)}
            onTouchTap={onTouchTap}>
            {leftIcon}
            <div className="CrawlerLink">
               <a href={`/book/${bookKey}/article/${articleKey}`}>{primaryText}</a>
            </div>
            <span style={Object.assign({}, styles.primaryText)}
                  onClick={(e) => isItemLeaf ? this.handleLinkClick(`/book/${bookKey}/article/${articleKey}`, e) : null}>
                    {primaryText}
            </span>
         </div>
      )
   }
}

ListItem.PropTypes = {
   bookKey: PropTypes.string.isRequired,
   articleKey: PropTypes.string.isRequired,
   primaryText: PropTypes.string.isRequired,
   isItemLeaf: PropTypes.bool.isRequired,
   style: PropTypes.object.isRequired,
	isActive: PropTypes.bool.isRequired,
   leftIcon: PropTypes.element,
   rightIcon: PropTypes.element,
   onTouchTap: PropTypes.func
};

const mapDispatchToProps = (dispatch) => ({
   actions: bindActionCreators(actionCreators, dispatch)
});

export default connect(mapDispatchToProps)(ListItem);



// WEBPACK FOOTER //
// ./src/components/ListItem.js